// Generated by purs version 0.15.0
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
var WontDeliver = /* #__PURE__ */ (function () {
    function WontDeliver() {

    };
    WontDeliver.value = new WontDeliver();
    return WontDeliver;
})();
var Ok = /* #__PURE__ */ (function () {
    function Ok(value0) {
        this.value0 = value0;
    };
    Ok.create = function (value0) {
        return new Ok(value0);
    };
    return Ok;
})();
var ChangeRestaurant = /* #__PURE__ */ (function () {
    function ChangeRestaurant(value0) {
        this.value0 = value0;
    };
    ChangeRestaurant.create = function (value0) {
        return new ChangeRestaurant(value0);
    };
    return ChangeRestaurant;
})();
var genericDeliveryStatus = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return WontDeliver.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Ok(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new ChangeRestaurant(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Services.Delivery (line 25, column 1 - line 25, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof WontDeliver) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Ok) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ChangeRestaurant) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Services.Delivery (line 25, column 1 - line 25, column 66): " + [ x.constructor.name ]);
    }
};
var showDeliveryStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDeliveryStatus)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "WontDeliver";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Array_NonEmpty_Internal.showNonEmptyArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "deliveryCost";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "freeThreshold";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "minOrderValue";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "path";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantSlug";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Data_Show.showString))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Money_Rounded.showMoney)))(Data_Money_Rounded.showMoney)))))({
        reflectSymbol: function () {
            return "Ok";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "deliveryInfo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "path";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "deliveryCost";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "freeThreshold";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "minOrderValue";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "path";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantSlug";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Data_Show.showString))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Money_Rounded.showMoney)))(Data_Money_Rounded.showMoney))))))({
        reflectSymbol: function () {
            return "ChangeRestaurant";
        }
    }))))
};
var fromOk = function (restaurantId) {
    return function (v) {
        if (v instanceof Ok) {
            return Data_Foldable.find(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(function (di) {
                return Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(restaurantId)(di.restaurantId);
            })(v.value0);
        };
        return Data_Maybe.Nothing.value;
    };
};
var eqDeliveryStatus = {
    eq: function (x) {
        return function (y) {
            if (x instanceof WontDeliver && y instanceof WontDeliver) {
                return true;
            };
            if (x instanceof Ok && y instanceof Ok) {
                return Data_Eq.eq(Data_Array_NonEmpty_Internal.eqNonEmptyArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                    reflectSymbol: function () {
                        return "restaurantSlug";
                    }
                })(Data_Eq.eqString))()({
                    reflectSymbol: function () {
                        return "restaurantName";
                    }
                })(Data_Eq.eqString))()({
                    reflectSymbol: function () {
                        return "restaurantId";
                    }
                })(Restaumatic_Restaurant_Types_Id.eqRestaurantId))()({
                    reflectSymbol: function () {
                        return "path";
                    }
                })(Data_Eq.eqString))()({
                    reflectSymbol: function () {
                        return "minOrderValue";
                    }
                })(Data_Money_Rounded.eqMoney))()({
                    reflectSymbol: function () {
                        return "freeThreshold";
                    }
                })(Data_Maybe.eqMaybe(Data_Money_Rounded.eqMoney)))()({
                    reflectSymbol: function () {
                        return "deliveryCost";
                    }
                })(Data_Money_Rounded.eqMoney))))(x.value0)(y.value0);
            };
            if (x instanceof ChangeRestaurant && y instanceof ChangeRestaurant) {
                return Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value0.deliveryInfo.deliveryCost)(y.value0.deliveryInfo.deliveryCost) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Money_Rounded.eqMoney))(x.value0.deliveryInfo.freeThreshold)(y.value0.deliveryInfo.freeThreshold) && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value0.deliveryInfo.minOrderValue)(y.value0.deliveryInfo.minOrderValue) && x.value0.deliveryInfo.path === y.value0.deliveryInfo.path && Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.value0.deliveryInfo.restaurantId)(y.value0.deliveryInfo.restaurantId) && x.value0.deliveryInfo.restaurantName === y.value0.deliveryInfo.restaurantName && x.value0.deliveryInfo.restaurantSlug === y.value0.deliveryInfo.restaurantSlug && x.value0.path === y.value0.path && Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.value0.restaurantId)(y.value0.restaurantId) && x.value0.restaurantName === y.value0.restaurantName;
            };
            return false;
        };
    }
};
var deliveryCostOrFree = function (v) {
    return function (v1) {
        if (v1 instanceof Data_Maybe.Nothing) {
            return Data_Maybe.Nothing.value;
        };
        if (v1 instanceof Data_Maybe.Just) {
            return new Data_Maybe.Just((function () {
                if (v1.value0.freeThreshold instanceof Data_Maybe.Nothing) {
                    return v1.value0.deliveryCost;
                };
                if (v1.value0.freeThreshold instanceof Data_Maybe.Just) {
                    var $32 = Data_Ord.greaterThanOrEq(Data_Money_Rounded.ordMoney)(v)(v1.value0.freeThreshold.value0);
                    if ($32) {
                        return Data_Numeric.zero(Data_Money_Rounded.additiveMoney);
                    };
                    return v1.value0.deliveryCost;
                };
                throw new Error("Failed pattern match at Restaumatic.Services.Delivery (line 64, column 78 - line 66, column 66): " + [ v1.value0.freeThreshold.constructor.name ]);
            })());
        };
        throw new Error("Failed pattern match at Restaumatic.Services.Delivery (line 62, column 1 - line 62, column 65): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
export {
    WontDeliver,
    Ok,
    ChangeRestaurant,
    fromOk,
    deliveryCostOrFree,
    genericDeliveryStatus,
    eqDeliveryStatus,
    showDeliveryStatus
};
//# sourceMappingURL=index.js.map
